import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { data } from "jquery";
import CustomButton from "../CustomButton";

function Type({ data, handleStep, setData }) {
  const [value, setValue] = useState({
    selectedType: data.selectedType,
    selectedSubType: data.selectedSubType,
    selectedTypeName: data.selectedTypeName,
    selectedSubTypeName: data.selectedSubTypeName,
    first_time_sponosr: "",
  });

  const [errors, setErrors] = useState({
    selectedType: "",
    selectedSubType: "",
  });

  const handleChange = (e) => {
    const { name, value: inputValue } = e.target;
    
    setValue({
      ...value,
      [name]: inputValue,
    });

     setErrors({
      ...errors,
      [name]: "",
    });

  };

  const handleCheckBox = (e) => {
    setValue({
      ...value,
      [e.target.name]: e.target.checked,
    });
  };

  const validateForm = () => {
    let isValid = true;

    const newErrors = {
      selectedType: "",
      selectedSubType: "",
    };

    if (!value.selectedType) {
      newErrors.selectedType = "Please select Registration Type.";
      isValid = false;
    }

    if (!value.selectedSubType) {
      newErrors.selectedSubType = "Please select Registration Sub-Type.";
      isValid = false;
    }

    setErrors(newErrors);

    return isValid;
  };

  const submitInfo = (action) => {

      if (action === "next") {
      const isValid = validateForm();

      if (!isValid) {
        return;
      }
    }

    let name = data.type
      .filter(
        (info) => info.registration_type_id.toString() === value.selectedType
      )
      .map((val) => val.registration_type_title);

    let subInfo = data.subType
      .filter(
        (info) =>
          info.registration_sub_type_id.toString() === value.selectedSubType
      )
      .map((val) => {
        let information = {
          title: val.title,
          fee:
            parseInt(val.sponsors_fee, 10) + parseInt(val.registration_fee, 10),
        };
        return information;
      });

    let val = {
      ...value,
      selectedTypeName: name && name[0],
      selectedSubTypeName: subInfo.length && subInfo[0].title,
      typeFee: subInfo.length && subInfo[0].fee,
    };
    handleStep(val, action, "type");
  };

  return (
    <div className="col-lg-6 col-sm-6 col-12 m-auto">
      <div className="glass-effect space">

        <Form>
          <div className="p-17">
            <Form.Group className="mt-16">
              <Form.Label className="form-label">Registration Type</Form.Label>
              <Form.Select
                className="dropDown"
                name="selectedType"
                value={value.selectedType}
                onChange={(e) => {
                  setData({
                    ...data,
                    tempIds: [],
                    eventIds: [],
                    guestEventIds: [],
                    sub_event_list: [],
                    guest_sub_event_list: [],
                    wholesalerlist: [],
                  });

                  setValue({
                    ...value,
                    selectedType: e.target.value,
                    selectedSubType: "",
                    selectedTypeName: "",
                    selectedSubTypeName: "",
                  });
                  
                  setErrors({
                    selectedType: "",
                    selectedSubType: "",
                  });
                }}
              >
                <option value="" disabled>
                  Select type
                </option>
                {data.type.map((data, index) => {
                  return (
                    <option
                      value={data.registration_type_id}
                      key={data.registration_type_id}
                    >
                      {data.registration_type_title}
                    </option>
                  );
                })}
              </Form.Select>

               {errors.selectedType && (
                <div
                  style={{
                    color: "#FF0000",
                    fontSize: "13px",
                    marginTop: "6px",
                  }}
                >
                  {errors.selectedType}
                </div>
              )}

            </Form.Group>
          </div>
          <div className="p-17 mt-20">
            <Form.Group className="mt-16">
              <Form.Label className="form-label">Registration Sub-Type</Form.Label>
              <Form.Select
                disabled={!value.selectedType}
                className="dropDown"
                name="selectedSubType"
                value={value.selectedSubType}
                onChange={(e) => {
                  setData({
                    ...data,
                    tempIds: [],
                    eventIds: [],
                    guestEventIds: [],
                    sub_event_list: [],
                    guest_sub_event_list: [],
                    wholesalerlist: [],
                  });
                  handleChange(e);
                }}
              >
                <option value="" disabled>
                  Select type
                </option>
                {data.subType
                  .filter(
                    (info) =>
                      info.registration_type_id === value.selectedType
                  )
                  .map((data) => {
                    return (
                      <option
                        value={data.registration_sub_type_id}
                        key={data.registration_sub_type_id}
                      >
                        {data.title}{" "}
                        {data.registration_type_id === "2"
                          ? "($" +
                          data.registration_fee +
                          "+" +
                          "$" +
                          data.sponsors_fee +
                          ")"
                          : ""}
                      </option>
                    );
                  })}
              </Form.Select>
               {errors.selectedSubType && (
                <div
                  style={{
                    color: "#FF0000",
                    fontSize: "13px",
                    marginTop: "6px",
                  }}
                >
                  {errors.selectedSubType}
                </div>
              )}
            </Form.Group>

          </div>

          {value.selectedType === "2" ? (
            <div className="p-17 mt-20">
              <Row>
                <Col xs={12}>
                  <Form.Check
                    type="checkbox"
                    label="Are you a first time company to sponsor?"
                    id="custom-switch"
                    name="first_time_sponosr"
                    checked={value.first_time_sponosr}
                    onChange={(e) => handleCheckBox(e)}
                  />
                </Col>
              </Row>
            </div>
          ) : (
            ""
          )}
        </Form>
        <div className="arrow-container">
          <button className="eg-btn btn--primary2 capsule prev mt-20" onClick={() => submitInfo("previous")} ><CustomButton /> Prev
          </button>
          <button  type="button"
            className="eg-btn btn--primary2 capsule mt-20"
            onClick={() => submitInfo("next")}>
            Next<CustomButton />
          </button>
        </div>
      </div>
    </div>
  );
}

export default Type;
